import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Loader from "../../utils/Loading";
import "./campaignForm.css";
import { useCampaignPrefill } from "../../context/CampaignPrefillContext";
import { getStoredCampaignPrefill } from "../../utils/campaignPrefillStorage";
import Form1 from "./Forms/Form1";
import Form2 from "./Forms/Form2";
import Form3 from "./Forms/Form3";
import Form4 from "./Forms/Form4";
import Form5 from "./Forms/Form5";
import Form6 from "./Forms/Form6";
import Form7 from "./Forms/Form7";

const CampaignForm: React.FC = () => {
  const { prefill: contextPrefill, jobSpecificationId: contextJobSpecId } =
    useCampaignPrefill();
  const storedPrefill = getStoredCampaignPrefill();
  const activePrefill = contextPrefill || storedPrefill?.prefill || null;
  const isPrefillCreateFlow = Boolean(
    contextPrefill || storedPrefill?.prefill
  );
  const jobSpecId = isPrefillCreateFlow
    ? contextJobSpecId ||
      storedPrefill?.jobSpecificationId ||
      activePrefill?.campaignPrefill?.jobSpecificationId ||
      null
    : null;
  const storedJobTitle = (() => {
    try {
      const stored = localStorage.getItem("CompaignData");
      if (!stored) return "";
      const parsed = JSON.parse(stored);
      return (
        (parsed?.Form1Data?.jobTitle?.name as string) ||
        (parsed?.Form5Data?.campaignData?.jobTitle as string) ||
        ""
      );
    } catch {
      return "";
    }
  })();

  const vonqMappingTitle = (
    activePrefill?.vonqMapping?.jobTitle as { description?: string } | undefined
  )?.description;

  const form1PrefillTitle = (
    activePrefill?.campaignPrefill?.form1?.jobTitle as { name?: string } | undefined
  )?.name;

  const jobTitle =
    vonqMappingTitle ||
    form1PrefillTitle ||
    storedJobTitle ||
    "";

  const isEditFlow = (() => {
    try {
      const stored = localStorage.getItem("CompaignData");
      if (!stored) return false;
      return Boolean(JSON.parse(stored)?._isEditFlow);
    } catch {
      return false;
    }
  })();

  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const nextStep = () => setActiveStep((prev) => prev + 1);
  const prevStep = () => setActiveStep((prev) => prev - 1);

  // Scroll to top on step change
  useEffect(() => {
    const container = document.querySelector(".container");
    if (container) {
      container.scrollIntoView({ block: "start", behavior: "auto" });
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [activeStep]);

  // Clear stored campaign context when leaving the campaign flow (unmount)
  const handleBeforeUnload = () => {
    try {
      localStorage.removeItem("CompaignData");
    } catch (error) {
      setError("Failed to remove CompaignData from localStorage:" + error);
    }
  };

  useEffect(() => {
    return () => {
      // Clear when navigating away from the campaign form
      try {
        localStorage.removeItem("CompaignData");
      } catch {}
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const getStepContent = () => {
    switch (activeStep) {
      case 0:
        return <Form1 nextStep={nextStep} />;
      case 1:
        return <Form2 nextStep={nextStep} prevStep={prevStep} />;
      case 2:
        return <Form3 nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <Form4 nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <Form5 nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return <Form6 nextStep={nextStep} prevStep={prevStep} />;
      case 6:
        return <Form7 prevStep={prevStep} />;
      default:
        return <Form1 nextStep={nextStep} />; // Fallback to first form if step is out of range
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="container pb-5">
        {isPrefillCreateFlow && !isEditFlow && jobSpecId && jobTitle && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: "12px",
              bgcolor: "#ecfdf5",
              border: "1px solid #a7f3d0",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Creating campaign for job specification
            </Typography>
            <Typography fontWeight={700}>{jobTitle}</Typography>
          </Box>
        )}
        {getStepContent()}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default CampaignForm;
